import React, { useEffect, useState } from "react";
import http from "../../../src/Redux/services/http-common.jsx";

function Eprescription({ scheduledata, closeFun }) {
  const [datajson, setDatajson] = useState(null);

  // Helper function to extract display value from objects
  const getDisplayValue = (value) => {
    if (value === null || value === undefined) return null;
    if (Array.isArray(value)) {
      // If it's an array, join the values
      return value.map(item => getDisplayValue(item)).join(", ");
    }
    if (typeof value === "object") {
      // Handle objects with label, value, or code properties
      return value.label || value.value || value.code || value.name || JSON.stringify(value);
    }
    return value;
  };

  // Format gender: F -> Female, M -> Male
  const formatGender = (genderValue) => {
    if (!genderValue) return "";
    const upperGender = String(genderValue).toUpperCase();
    if (upperGender === "F") return "Female";
    if (upperGender === "M") return "Male";
    return genderValue; // Return as-is if already formatted or unknown
  };

  useEffect(() => {
    if (!scheduledata?.patientCode || !scheduledata?.id) return;

    let url = `${process.env.REACT_APP_BASEURL}PatientDocument/getDocuments?reportType=D01&patientCodes=${scheduledata.patientCode}&order=DESC&id=${scheduledata.id}`;

    console.log("Fetching URL:", url);

    http
      .get(url)
      .then((res) => {
        console.log(res?.data, "esdtrfhujiko");
        const smartdocArray = res?.data?.data.map((item) => {
          try {
            return JSON.parse(item?.smartDoc);
          } catch (error) {
            console.error("Error parsing smartDoc:", error);
            return null;
          }
        });

        if (smartdocArray.length > 0) {
          setDatajson(smartdocArray[0]);
        }

        console.log("Parsed Data:", smartdocArray);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [scheduledata]);
  console.log(datajson, "sdfghjkfghjk");

  if (!datajson) {
    return <div>Loading Prescription...</div>;
  }
  
  if (!datajson.data) {
    return <div>No prescription data available</div>;
  }
  
  console.log(datajson.data, "sedrftgyhujikl");
  const {
    firstName,
    lastName,
    mobile,
    docName,
    visitDate,
    chiefComplaint,
    symptoms,
    primaryDiagnosis,
    primarySymptoms,
    secondaryDiagnosis,
    secondarySymptoms,
    recommendation,
    patientDrugPrescriptionList,
    medicine_details,
    patientLabTestsList,
    diagnosis = {},
    patient_details = {},
    lab_test_details = {},
  } = datajson.data;

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "10px",
        border: "1px solid #ccc",
        margin: "auto",
      }}
    >
      <h3>{getDisplayValue(patient_details?.ref_doctor)}</h3>

      <hr />

      {/* Patient Details */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
          border: "1px solid #ccc",
        }}
      >
        <tbody>
          <tr style={{ borderBottom: "1px solid #ccc", background: "#f5f5f5" }}>
            <td
              style={{
                padding: "8px",
                fontWeight: "bold",
                borderRight: "1px solid #ccc",
              }}
            >
              Name:
            </td>
            <td style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
              {getDisplayValue(patient_details?.name)}
            </td>
            <td
              style={{
                padding: "8px",
                fontWeight: "bold",
                borderRight: "1px solid #ccc",
              }}
            >
              Age:
            </td>
            <td style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
              {getDisplayValue(patient_details?.age) || "N/A"}
            </td>
            <td
              style={{
                padding: "8px",
                fontWeight: "bold",
                borderRight: "1px solid #ccc",
              }}
            >
              Hospital:
            </td>
            <td style={{ padding: "8px" }}>eClinic</td>
          </tr>
          <tr>
            <td
              style={{
                padding: "8px",
                fontWeight: "bold",
                borderRight: "1px solid #ccc",
              }}
            >
              Gender:
            </td>
            <td style={{ padding: "8px", borderRight: "1px solid #ccc" }}>
              {formatGender(getDisplayValue(patient_details?.gender))}
            </td>
            {/* <td style={{ padding: "8px", fontWeight: "bold", borderRight: "1px solid #ccc" }}>Visit Type:</td>
          <td style={{ padding: "8px" , }}></td> */}
            <td
              style={{
                padding: "8px",
                fontWeight: "bold",
                borderRight: "1px solid #ccc",
              }}
            >
              Visit Date:
            </td>
            <td style={{ padding: "8px" }}>{getDisplayValue(patient_details?.tested_on)}</td>
          </tr>
        </tbody>
      </table>

      <h3>
        Chief Complaint:{" "}
        <span style={{ fontWeight: "400" }}>{getDisplayValue(chiefComplaint) || "N/A"}</span>
      </h3>
      <h3>
        Symptoms: <span style={{ fontWeight: "400" }}>{getDisplayValue(symptoms) || "N/A"}</span>
      </h3>

      <h3>
        Primary Diagnosis::{" "}
        <span style={{ fontWeight: "400" }}>{getDisplayValue(diagnosis?.primary) || "N/A"}</span>
      </h3>
      {diagnosis?.secondary && (
        <>
          <h3>
            Secondary Diagnosis::{" "}
            <span style={{ fontWeight: "400" }}>
              {getDisplayValue(diagnosis.secondary) || "N/A"}
            </span>
          </h3>
        </>
      )}

      {/* Medicines */}
      <h3>Medicines Prescribed:</h3>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
          border: "1px solid #ccc",
        }}
      >
        <thead>
          <tr style={{ background: "#f4f4f4" }}>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>#</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>
              Medication
            </th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Dosage</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>Qty</th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>
              Instruction
            </th>
            <th style={{ padding: "8px", border: "1px solid #ddd" }}>
              Duration
            </th>
          </tr>
        </thead>
        <tbody>
          {medicine_details?.map((drug, index) => (
            <tr key={index}>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {index + 1}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {/* {drug.drugName} ({drug.composition}) */}
                {getDisplayValue(drug.name)}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {getDisplayValue(drug.dosage)}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {getDisplayValue(drug.quantity)}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {getDisplayValue(drug.instructions)}
              </td>
              <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                {getDisplayValue(drug.duration)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Lab Tests */}
      {lab_test_details?.tests?.length > 0 && (
        <>
          <h3>Lab Tests:</h3>
          <ul>
            {lab_test_details.tests.map((test, index) => (
              <li key={index}>{getDisplayValue(test)}</li>
            ))}
          </ul>
        </>
      )}

      {/* Recommendation */}
      <h3>Recommendation:</h3>
      <p>{getDisplayValue(recommendation) || "N/A"}</p>

      <div style={{ marginTop: "10px" }}>
        <h3>Disclaimer :</h3>
        <ul
          style={{ marginTop: "5px", paddingLeft: "20px", lineHeight: "1.5" }}
        >
          <li>
            The information and advice provided here is provisional in nature as
            it is based on the limited information made available by the patient
          </li>
          <li>
            The patient is advised to visit in person for thorough examination
            at the earliest
          </li>
          <li>
            The information is confidential in nature and for recipient’s use
            only
          </li>
          <li>The Prescription is generated on a Teleconsultation</li>
          <li>Not valid for medico-legal purpose</li>
        </ul>
      </div>
    </div>
  );
}

export default Eprescription;
